import React from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import AnimatedSection from "../../components/AnimatedSection/AnimatedSection";
import GalleryStrip from "../../components/GalleryStrip/GalleryStrip";
import { PROJECTS } from "../../data/projects";
import { SERVICES } from "../../data/services";
import "./ProjectDetail.css";

function ProjectDetail() {
  const { id } = useParams();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const project = PROJECTS.find((p) => p.id === id);

  if (!project) {
    return (
      <div className="not-found">
        <p>{t("service_detail.not_found").replace("Service", "Project").replace("सेवा", "प्रोजेक्ट")}</p>
        <button className="btn-outline" onClick={() => navigate("/projects")}>{"← Back"}</button>
      </div>
    );
  }

  const service = SERVICES.find((s) => s.id === project.service);

  // Use translations for category and location if we can, but fallback to project data.
  // We'll translate headers based on current language
  const isHi = t("home") === "होम";
  
  const details = [
    [isHi ? "श्रेणी" : "Category", t(`projects_data.${project.id}.category`, project.category)],
    [isHi ? "स्थान" : "Location", t(`projects_data.${project.id}.location`, project.location)],
    [isHi ? "क्षेत्र" : "Area", t(`projects_data.${project.id}.area`, project.area)],
    [isHi ? "प्रयुक्त सेवा" : "Service Used", service ? t(`services_data.${service.id}.title`, service.title) : "—"],
  ];

  return (
    <div className="project-detail" style={{ paddingTop: 66 }}>

      {/* Hero */}
      <div className="project-detail__hero">
        <img src={project.image} alt={`${t(`projects_data.${project.id}.title`, project.title)} — SK Associate`} className="project-detail__hero-bg" />
        <div className="project-detail__hero-overlay" />
        <div className="project-detail__hero-content container">
          <button className="project-detail__back" onClick={() => navigate("/projects")}>{"← Back"}</button>
          <span className="badge">{t(`projects_data.${project.id}.category`, project.category)}</span>
          <h1 className="project-detail__title">{t(`projects_data.${project.id}.title`, project.title)}</h1>
          <div className="project-detail__meta">
            <span>📍 {t(`projects_data.${project.id}.location`, project.location)}</span>
            <span>📐 {t(`projects_data.${project.id}.area`, project.area)}</span>
          </div>
        </div>
      </div>

      {/* Content */}
      <section className="section" style={{ background: "var(--bg2)" }}>
        <div className="container detail-grid">
          <AnimatedSection>
            <h2 className="project-detail__h2">{isHi ? "परियोजना का अवलोकन" : "PROJECT OVERVIEW"}</h2>
            <p className="project-detail__desc">{t(`projects_data.${project.id}.description`, project.description)}</p>
            <GalleryStrip images={project.gallery} title={isHi ? "प्रोजेक्ट चित्र" : "PROJECT IMAGES"} />
          </AnimatedSection>

          <AnimatedSection delay={0.2}>
            <div className="sidebar-card">
              <h3 className="project-detail__sidebar-title">{isHi ? "प्रोजेक्ट विवरण" : "PROJECT DETAILS"}</h3>
              {details.map(([k, v]) => (
                <div key={k} className="project-detail__detail-row">
                  <span className="project-detail__detail-key">{k}</span>
                  <span className="project-detail__detail-val">{v}</span>
                </div>
              ))}

              {service && (
                <button
                  className="btn-primary"
                  style={{ width: "100%", marginTop: 18 }}
                  onClick={() => navigate(`/services/${service.id}`)}
                >
                  {isHi ? "सेवा देखें" : "VIEW SERVICE"}
                </button>
              )}

              <button
                className="btn-outline"
                style={{ width: "100%", marginTop: 10 }}
                onClick={() => navigate("/contact")}
              >
                {t("navbar.cta")}
              </button>

              <div className="project-detail__sidebar-img">
                <img src={project.gallery[2]} alt={t(`projects_data.${project.id}.title`, project.title)} />
              </div>
            </div>
          </AnimatedSection>
        </div>
      </section>

    </div>
  );
}

export default ProjectDetail;
